import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import AutomService from "../../../../../../services/AutomService/AutomService";
import MateService from "../../../../../../services/MateService/MateService";

import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Close from "@material-ui/icons/Close";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { useRecoilState, useSetRecoilState } from 'recoil';
import {
    alertState,
    // triggerSelection
} from "../../../../../../recoil-store/recoil-state";
import QueuePoolService from "../../../../../../services/QueuePoolService/QueuePoolService";

const useStyles = makeStyles((theme) => ({
    input: {
        backgroundColor: "#fff",
        marginBottom: 20,
    },
    bottomSection: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
    },

    button: {
        border: "none",
        borderRadius: "5px",
        width: 100,
        height: 35,
        float: "right",
        "&:focus": {
            outline: "none",
        },
    },
    submit: {
        color: "white",
        marginLeft: 15,
        backgroundColor: "#079063",
        cursor: "pointer",
    },
    formLabel: {
        justifyContent: "left",
        alignItems: "center",
        display: "flex",
        position: "relative",
    },
    formLabelSemiColon: {
        position: "absolute",
        right: "0",
    },
}));

const EditAutomName = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const setAlert = useSetRecoilState(alertState);
    const handleClose = () => {
        props.setOpenEdit(false);
    };

    // const [triggerSelectionData, setTriggerSelectionData] = useRecoilState(triggerSelection);
    const [name, setName] = useState(props.automDetail?.name);
    const [description, setDescription] = useState(
        props.automDetail?.description
    );
    //const [integrationType, setIntegrationType] = useState( props.automDetail?.integration_type);
    const [flowTimeOut, setFlowTimeOut] = useState(props.automDetail?.timeout);
    const [mates, setMates] = useState([]);
    const [selectedMate, setSelectedMate] = useState(props.automDetail?.mate_id);
    const [queuePool, setSelectQueuePool] = useState(props.automDetail?.qpool_id);
    const [queuePoolData, setQueuePoolData] = useState([]);
    const [queueEnable, setQueueEnable] = useState(
        props.automDetail?.queue_enabled
    );
    // const [triggerType, setTriggerType] = useState({
    //     email: !!props.automDetail?.trigger_type?.split(",").includes("email"),
    //     webhook: !!props.automDetail?.trigger_type?.split(",").includes("webhook"),
    //     api: !!props.automDetail?.trigger_type?.split(",").includes("api"),
    // });
    const GetMates = async () => {
        const response = await MateService.getAllMates();
        if (response.status) {
            setMates(response.data);
        }
    };

    const GetQueuePools = async () => {
        const response = await QueuePoolService.getQueuePool();
        if (response.status) {
            setQueuePoolData(response.data);
        }
    }

    useEffect(() => {
        GetMates().then(r => r);
        GetQueuePools().then(r => r)
    }, []);

    const handleChange = (event) => {
        setQueueEnable(event.target.checked ? 1 : 0);
        setSelectQueuePool("")
    };

    let newFormData;
    const onSubmit = async () => {
        
        const mateId = selectedMate !== "" ? selectedMate : null;
        //let trigger_type = '';

        newFormData = {
            autom_id: props.automDetail.id,
            updatingFields: [
                { field_name: "name", field_value: name },
                { field_name: "description", field_value: description },
                //{field_name: "integration_type", field_value: integrationType},
                { field_name: "mate_id", field_value: mateId },
                { field_name: "queue_enabled", field_value: queueEnable },
                { field_name: "qpool_id", field_value: queuePool },
            ],
        };

        //let triggerSelectionData = [];
        // if (integrationType === "TRIGGER") {
        //     if (triggerType.email) {
        //         trigger_type = 'email'
        //     }
        //     if (triggerType.webhook) {
        //         trigger_type += `${trigger_type !== '' ? ',' : ''}webhook`
        //     }
        //     if (triggerType.api) {
        //         trigger_type += `${trigger_type === '' ? '' : ','}api`
        //     }
        //     // trigger_type = triggerType.email === true && triggerType.webhook
        //     //     ? "email,webhook"
        //     //     : triggerType.email === true
        //     //         ? "email"
        //     //         : "webhook";
        //     const updatingFieldTrigger = {
        //         field_name: "trigger_type",
        //         field_value: trigger_type,
        //     }
        //     triggerSelectionData = trigger_type.split(',');
        //     newFormData.updatingFields.push(updatingFieldTrigger);
        // } else if (integrationType === "SCHEDULE") {
        //     const updatingFieldTrigger = {
        //         field_name: "trigger_type",
        //         field_value: "schedule",
        //     }
        //     triggerSelectionData = ["schedule"];
        //     newFormData.updatingFields.push(updatingFieldTrigger);
        // }

        //setTriggerSelectionData(triggerSelectionData);



        // if (integrationType === "TRIGGER" && !triggerType.email && !triggerType.webhook && !triggerType.api) {
        //     setAlert(alert => ({
        //         ...alert,
        //         show: true,
        //         message: t("CONTENT.AUTOMS-LIST.TRIGGER-TYPE-REQUIRED"),
        //         severity: 'error'
        //     }));
        //     return;
        // }
        const response = await AutomService.updateAutom(
            newFormData,
            props.automDetail.id
        );
        if (response.status) {
            props.setAutomDetail({
                ...props.automDetail,
                name,
                description,
                // integration_type: integrationType,
                // trigger_type: trigger_type,
                mate_id: mateId,
                queue_enabled: queueEnable,
                qpool_id: queuePool,
            });
            props.setReCheck(!props.reCheck);
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS.AUTOM-EDITED"),
                severity: 'success'
            }));
            // props.setFirstRender(true);
            //if integration type is a trigger when , run function automaticallyVariableCreation
            // if (integrationType === "TRIGGER") {
            //     // let trigger =
            //     //     triggerType.email === true && triggerType.webhook
            //     //         ? "email,webhook"
            //     //         : triggerType.email === true
            //     //             ? "email"
            //     //             : "webhook";
            //     props.automaticallyVariableCreation(trigger_type);
            // }
            handleClose();
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS." + response.message),
                severity: 'error'
            }));
        }
    };

    // const handleIntegrationType = (event) => {
    //     let updatedData = {
    //         ...triggerType,
    //         [event.target.name]: event.target.checked
    //     }
    //     if (event.target.name === 'webhook' && event.target.checked) {
    //         updatedData.api = false
    //     } else if (event.target.name === 'api' && event.target.checked) {
    //         updatedData.webhook = false
    //     }
    //     setTriggerType(updatedData);
    // };

    return (
        <Dialog
            id="autom-addNew-modal"
            data-test="autom-add-new"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    minWidth: 400,
                    padding: "8px 24px 8px 24px",
                    overflowX: "hidden",
                },
            }}
        >
            <DialogTitle id="alert-dialog-title">
                <div id="about-title">
                    {t("CONTENT.AUTOMS-LIST.EDIT")}
                    <Button data-test="cancelautom-button" onClick={handleClose}>
                        <Close />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div style={{ textAlign: "left", marginTop: 20 }}>
                    <div className="form-element">
                        <div className="modal-text add-autom">
                            <div>{t("CONTENT.AUTOMS-LIST.AUTOM-NAME")}</div>
                        </div>
                        <TextField
                            id="filled-size-small"
                            autoFocus
                            style={{
                                float: "left",
                                backgroundColor: "#fff",
                                width: "100%",
                            }}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className={classes.input}
                            variant="outlined"
                            size="small"
                            inputProps={{ style: { fontSize: 12 } }}
                        />
                    </div>

                    <div className="form-element add-autom-input">
                        <div className="modal-text">
                            {t("CONTENT.AUTOMS-LIST.DESCRIPTION")}
                        </div>
                        <TextField
                            id="filled-size-small"
                            style={{ float: "left" }}
                            className={classes.input}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            variant="outlined"
                            size="small"
                            multiline
                            rows={5}
                            fullWidth
                            inputProps={{ style: { fontSize: 12 } }}
                        />
                    </div>
                    <div className="form-element add-autom-input">
                        <div className="modal-text">Action Timeout(ms)</div>
                        <TextField
                            id="filled-size-small"
                            style={{ float: "left" }}
                            className={classes.input}
                            value={flowTimeOut}
                            onChange={(e) => setFlowTimeOut(e.target.value)}
                            variant="outlined"
                            size="small"
                            type="number"
                            fullWidth
                            inputProps={{ style: { fontSize: 12 } }}
                        />
                        {flowTimeOut < 2000 ? (
                            <small>Please enter over 2000 ms</small>
                        ) : null}
                    </div>
                    {/* <div className="form-element">
                        <div className="modal-text" style={{marginBottom: 5}}>
                            {t("CONTENT.AUTOMS-LIST.TYPE")}
                        </div>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{width: "100%"}}
                        >
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                style={{
                                    backgroundColor: "#fff",
                                    height: "40px",
                                    fontSize: "12px",
                                }}
                                id="demo-simple-select-outlined"
                                value={integrationType}
                                onChange={(e) => setIntegrationType(e.target.value)}
                            >
                                <MenuItem style={{fontSize: 12}} value="STANDARD">
                                    {t("CONTENT.AUTOMS-LIST.STANDARD")}
                                </MenuItem>
                                <MenuItem style={{fontSize: 12}} value="SCHEDULE">
                                    {t("CONTENT.AUTOMS-LIST.SCHEDULE")}
                                </MenuItem>
                                <MenuItem style={{fontSize: 12}} value="TRIGGER">
                                    {t("CONTENT.AUTOMS-LIST.TRIGGER")}
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </div> */}
                    {/* {integrationType === "TRIGGER" ? (
                        <>
                            <div className="form-element">
                                <div className="modal-text">
                                    {t("CONTENT.AUTOMS-LIST.TRIGGER-TYPE")}
                                </div>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={triggerType.email}
                                            onChange={handleIntegrationType}
                                            name="email"
                                            color="default"
                                            size="small"
                                        />
                                    }
                                    label="E-mail"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={triggerType.webhook}
                                            onChange={handleIntegrationType}
                                            name="webhook"
                                            color="default"
                                            size="small"
                                        />
                                    }
                                    label="Webhook"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={triggerType.api}
                                            onChange={handleIntegrationType}
                                            name="api"
                                            color="default"
                                            size="small"
                                        />
                                    }
                                    label="Api"
                                />
                            </div>
                        </>
                    ) : null} */}
                    <div className="form-element">
                        <div className="modal-text">Mate</div>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: "100%" }}
                        >
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                style={{
                                    backgroundColor: "#fff",
                                    height: "40px",
                                    fontSize: "12px",
                                }}
                                id="demo-simple-select-outlined"
                                value={selectedMate}
                                onChange={(e) => setSelectedMate(e.target.value)}
                            >
                                {mates.length > 0 &&
                                    mates.map((mate) => (
                                        <MenuItem
                                            key={mate.id}
                                            style={{ fontSize: 12 }}
                                            value={mate.id}
                                        >
                                            {mate.device_name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="form-element">
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: "100%" }}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={queueEnable}
                                        size="small"
                                        color="#C4C4C4"
                                        inputName="queueEnable"
                                        onChange={handleChange}
                                    />
                                }
                                label={
                                    <div className="modal-text">
                                        {t("CONTENT.AUTOMS-LIST.QUEUE-ENABLED")}
                                    </div>
                                }
                            />
                        </FormControl>
                    </div>
                    {queueEnable ? (
                        <div className="form-element">
                            <div className="modal-text">{t("CONTENT.AUTOMS-LIST.RELATED-QUEUE-POOL")}</div>
                            <FormControl
                                variant="outlined"
                                className={classes.formControl}
                                style={{ width: "100%" }}
                            >
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    style={{
                                        backgroundColor: "#fff",
                                        height: "40px",
                                        fontSize: "12px",
                                    }}
                                    id="demo-simple-select-outlined"
                                    value={queuePool}
                                    onChange={(e) => setSelectQueuePool(e.target.value)}
                                >
                                    {queuePoolData?.map(data => <MenuItem value={data.id}>{data.pool_name}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </div>
                    ) : null}
                </div>
            </DialogContent>
            <DialogActions
                style={{
                    justifyContent: "space-between",
                    padding: "8px 24px 16px 24px",
                }}
            >
                <div className={classes.bottomSection}>
                    <button
                        type="button"
                        onClick={onSubmit}
                        data-test="createautom-button"
                        className={`${classes.button} ${classes.submit}`}
                        style={{
                            backgroundColor: "#162436",
                            borderRadius: "4px",
                            color: "#fff",
                            boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)",
                        }}
                    >
                        {t("CONTENT.AUTOMS-LIST.EDIT")}
                    </button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default EditAutomName;
